




import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { closeAllModal, showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import { driverSearch } from "../../../features/joblist/jobListSlice"
import { profilSurucuSorgu } from "../../../features/companyProfile/companyProfileSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            padding: 40px;
            
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
        }
        .btn-container{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
    }
`

const ProfilSearchSurucuModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [phoneValue, setPhoneValue] = useState("")
    
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSearch = (query) => {
       dispatch(profilSurucuSorgu(query))
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Sürücü Ara"}/>
        <div className="content">
          <InputPhoneFormat inputWidth={"420px"} data={phoneValue} setData={setPhoneValue} labelText={"Telefon Numarası"} />
        </div>

        <div className="btn-container">
            <Btn bgColor={"#E85446"} color={"#fff"} width={"200px"} handleClick={() => handleSearch(phoneValue.slice(2))} >Devam Et</Btn>
            <Btn bgColor={"transparent"} color={"#E85446"} width={"200px"} handleClick={() => dispatch(showModal(null))} >Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default ProfilSearchSurucuModal